import React from "react";
import { useSelector } from "react-redux";
import CourseInfoTile from "../components/CourseInfoTile";
import Loader from "../components/Loader";

function Messages({ newMessages, setNewMessages }) {
  const courses = useSelector((state) => state.pwaData?.courses);

  if (courses.length === 0) {
    return <Loader />;
  }
  return (
    <div className="body-container">
      <h1 className="page-heading">Messages</h1>
      {courses.map((course) => (
        <CourseInfoTile
          key={course._id || course?.course_id?._id}
          course={course}
          newMessages={newMessages}
          setNewMessages={setNewMessages}
        />
      ))}
    </div>
  );
}

export default Messages;
